import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  isolation: isolate;
  min-height: 380px;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: var(--text-primary, #faf8f7);
  padding: 100px 24px 0;
  @media (min-width: 1024px) {
    justify-content: center;
  }

  .btn {
    background: #c8ff26;
    .action {
      color: #000;
    }
  }
`;

export const ReferralTitle = styled.h1`
  margin: 0;
  font-weight: 400;
  font-variation-settings: "wght" 700;
  font-size: 48px;
  line-height: 56px;
  margin-top: 36px;
  @media (min-width: 1024px) {
    margin-top: -210px;
  }
`;

export const InvitationDecoration = styled.img`
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 800px;
  height: auto;
  object-fit: contain;
  object-position: center bottom;
  z-index: -1;
`;
